import { render } from "./Privacy.vue?vue&type=template&id=b3eed7f4&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=b3eed7f4&scoped=true&lang=css"

import exportComponent from "/Users/bahramhasanov/Downloads/_TRASH/loyalty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3eed7f4"]])

export default __exports__